import React, { useEffect, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import {
  ManageContainer,
  ManageHeader,
  ManageWrapper,
  MemberAddButton,
  MemberContainer,
} from './manageMembersElements';
import MemberTable from '../../Utils/table/memberManageTable';
import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import LoadingSection from '../Loading';
import Popup from '../../Utils/popup/popup';
import AddMemberPopup from '../../Utils/popup/addMember/addMemberPopup';
import ROLES from '../../Utils/roles';

const ManageMembersSection = () => {
  const axiosPrivate = useAxiosPrivate();
  const [loading, setLoading] = useState(true);

  const [admins, setAdmins] = useState([]);
  const [teams, setTeams] = useState([]);

  const [adminOpen, setAdminOpen] = useState(false);
  const [teamOpen, setTeamOpen] = useState(false);

  // Get initial data
  useEffect(() => {
    axiosPrivate.get('/getMembers', {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then((res) => {
      setAdmins(res.data.admins);
      setTeams(res.data.teams);
      setLoading(false);
    }).catch((error) => {
      console.log(error);
    });
  }, []);

  return (
    <ManageContainer>
      <Popup header="Add admin" trigger={adminOpen} setOpen={setAdminOpen}>
        <AddMemberPopup
          setOpen={setAdminOpen}
          setData={setAdmins}
          role={ROLES.Admin}
        />
      </Popup>
      <Popup header="Add team member" trigger={teamOpen} setOpen={setTeamOpen}>
        <AddMemberPopup
          setOpen={setTeamOpen}
          setData={setTeams}
          role={ROLES.Team}
        />
      </Popup>
      <ManageWrapper>
        {loading ? (
          <LoadingSection isSmall />
        ) : (
          <>
            <MemberContainer>
              <ManageHeader>Admins</ManageHeader>
              <MemberTable data={admins} setData={setAdmins} />
              <MemberAddButton onClick={() => setAdminOpen(true)}>
                Add admin
                <AiOutlinePlus style={{ marginLeft: '5px' }} />
              </MemberAddButton>
            </MemberContainer>
            <MemberContainer>
              <ManageHeader>Team Members</ManageHeader>
              <MemberTable data={teams} setData={setTeams} />
              <MemberAddButton onClick={() => setTeamOpen(true)}>
                Add team member
                <AiOutlinePlus style={{ marginLeft: '5px' }} />
              </MemberAddButton>
            </MemberContainer>
          </>
        )}
      </ManageWrapper>
    </ManageContainer>
  );
};

export default ManageMembersSection;
